<template>
    <CardPage :section="5" :page="5" :backOverrideFunction="backClick" :nextDisabled="nextDisabled" ref="cardPage">
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="'list' === mode">
                <p>
                    To get what she wants, there are a couple of ways Billi could respond, but they might not all work so great to get her what she wants. Click
                    on the communication styles to see how each plays out.
                </p>
                <v-layout row justify-center>
                    <v-flex xs6>
                        <div v-for="(key, index) in stylesOrder" :key="index" class="style">
                            <v-btn block large round :color="styles[key].color" @click="select(styles[key])" :class="{ visited: styles[key].text }">
                                {{ styles[key].title }}
                            </v-btn>
                            <div class="check" v-if="styles[key].text">
                                <v-avatar class="success">
                                    <v-icon dark>check</v-icon>
                                </v-avatar>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="'video' === mode">
                <video controls controlslist="nodownload" @playing="playing" @ended="ended">
                    <source :src="styles[selectedStyle].video.src" type="video/mp4" />
                    <track kind="captions" srclang="en" :src="styles[selectedStyle].video.captions" />
                </video>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="'summary' === mode">
                <p>{{ styles[selectedStyle].summary }}</p>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="'entry' === mode">
                <p>{{ styles[selectedStyle].prompt }}</p>
                <v-textarea outline auto-grow :value="styles[selectedStyle].text" @input="update"></v-textarea>
            </div>
        </v-slide-x-reverse-transition>
        <template v-if="'list' !== mode || nextDisabled()" v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn
                v-if="'video' === mode"
                @click="transition('summary')"
                round
                large
                color="primary"
                :disabled="!(styles[selectedStyle].video.started && styles[selectedStyle].video.completed)"
                >Next</v-btn
            >
            <v-btn v-if="'summary' === mode" @click="transition('entry')" round large color="primary">Next</v-btn>
            <v-btn v-if="'entry' === mode" @click="transition('list')" round large color="primary" :disabled="!styles[selectedStyle].text">Done</v-btn>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import router from '@/router';
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            mode: 'list',
            selectedStyle: null
        };
    },
    computed: {
        styles: get('section5/styles'),
        stylesOrder: get('section5/stylesOrder'),
        allStylesEntered: get('section5/allStylesEntered')
    },
    methods: {
        backClick() {
            if ('list' === this.mode) {
                router.back();
            } else if ('video' === this.mode) {
                this.transition('list');
            } else if ('summary' === this.mode) {
                this.transition('video');
            } else if ('entry' === this.mode) {
                this.transition('summary');
            }
        },
        nextDisabled() {
            return !this.allStylesEntered;
        },
        select(style) {
            this.selectedStyle = style.id;
            this.transition('video');
        },
        transition(mode) {
            this.mode = mode;
            if ('list' === mode) {
                if (this.allStylesEntered) {
                    this.$refs.cardPage.nextClick();
                }
            }
        },
        update(text) {
            this.$store.set(`section5/styles@${this.selectedStyle}.text`, text);
        },
        playing() {
            this.$store.set(`section5/styles@${this.selectedStyle}.video.started`, true);
        },
        ended() {
            this.$store.set(`section5/styles@${this.selectedStyle}.video.completed`, true);
        }
    }
};
</script>

<style scoped>
video {
    width: 100% !important;
    height: auto !important;
}

.style {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}
.visited {
    opacity: 0.5;
}
</style>
